import styled from 'styled-components';

export const GetMoreLeadsContainer = styled.div`
  display: flex;
  margin: 100px auto;
`;

export const GetLeadsButtonContainer = styled.div`
  display: flex;
  margin: auto;
  flex-direction: column;
`;

export const GetMoreLeadsButton = styled.button`
  width: max-content;
  font-size: 19px;
  line-height: 26px;
  font-weight: 700;
  display: flex;
  align-items: center;
  padding: 11px 26px;
  color: #ffffff;
  background-color: ${props => (props.disabled ? '#B1B1B1' : '#2BA274')};
  box-shadow: 0px 2px 4px 0px rgba(129, 129, 129, 0.5);
  border-radius: 8px;
  margin: auto;
  margin-bottom: 10px;
  cursor: pointer;
`;

export const StackOfCoingImg = styled.img`
  margin-left: 25px;
  height: 40px;
`;

export const MoreLeadsMessage = styled.div`
  font-size: 19px;
  line-height: 26px;
  font-weight: 700;
  padding: 11px 26px;
  color: #32a275;
  margin: auto;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const ErrorReasonText = styled.div`
  margin: 30px auto;
  color: #7f7f7f;
  color: #a10303;
`;



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GetMoreLeads/styles.js